import { useQuery } from "@apollo/client";
import { DAILY_CHECK_IN_DATA } from "./daily-check-in.query";
import { IDailyCheckIn } from "./daily-check-in.interface";

export const useDailyCheckIn = () => {
  const { data, loading, error } = useQuery<{ getDailyCheckIn
: IDailyCheckIn }>(DAILY_CHECK_IN_DATA, {
  fetchPolicy: "cache-and-network",
});


  return {
    dailyCheckInData: data?.getDailyCheckIn,
    dailyCheckInLoading: loading,
    dailyCheckInError: error,
  };
};
